module.exports = __webpack_public_path__ + "img/第8章_4-3_賴和館4樓.jpg";